import { Injectable } from "@angular/core";
import { AssetClass, BlotterType, OpsExceptionType } from "shared/cubiq-model-multi-asset";
import * as CubiqTS from "shared/cubiq-model-multi-asset";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import {
  CcyLookupService,
  CcyPairLookupService,
  ColumnFilterType,
  IndexType,
  OpsIntEventPrivatizer,
  OpsIntLookupService,
  ProfilePromiseActionService,
} from "..";

import { BaseTableDefinitionFactory } from "./BaseTableDefinitionFactory";
import { BfxColDef, TableDefinition } from "./TableDefinition";
import { DIReasonHelper } from "./orders/DIReasonHelper";
import { TranslateService } from "@ngx-translate/core";
import { Optional } from "@angular/core";
import { TreeMultiMap } from "jstreemap";
import { ICellRendererParams, ValueFormatterParams, ValueGetterParams } from "ag-grid-community";
import { ConnectionMonitorConnectionsTableDefinitionFactory } from "./ConnectionMonitorConnectionsTableDefinitionFactory";

const DEFAULT_SORT: Array<{ colId: string; sort: string }> = [{ colId: "eventTime", sort: "desc" }];

const DEFAULT_CELL_CLASS: string = "ag-cell-default";

@Injectable()
export class ConnectionMonitorAuditTableDefinitionFactory extends ConnectionMonitorConnectionsTableDefinitionFactory {
  constructor(
    profileService: ProfilePromiseActionService,
    @Optional() protected _translate: TranslateService,
  ) {
    super(profileService, _translate);
  }

  public createDef(): TableDefinition {
    let tableDefinition: TableDefinition = super.createDef();

    let td = new TableDefinition("eventId", "as_sort_eventId");

    let statusColumn: BfxColDef = tableDefinition.getColumnDefinition(
      ConnectionMonitorConnectionsTableDefinitionFactory.COLUMN_STATUS,
    );
    let connectionColumn: BfxColDef = tableDefinition.getColumnDefinition(
      ConnectionMonitorConnectionsTableDefinitionFactory.COLUMN_CONNECTION,
    );
    let connectionGroupColumn: BfxColDef = tableDefinition.getColumnDefinition(
      ConnectionMonitorConnectionsTableDefinitionFactory.COLUMN_CONNECTION_GROUP,
    );
    let sessionColumn: BfxColDef = tableDefinition.getColumnDefinition(
      ConnectionMonitorConnectionsTableDefinitionFactory.COLUMN_SESSION,
    );
    let nodeColumn: BfxColDef = tableDefinition.getColumnDefinition(
      ConnectionMonitorConnectionsTableDefinitionFactory.COLUMN_NODE,
    );
    let eventTimeColumn: BfxColDef = tableDefinition.getColumnDefinition(
      ConnectionMonitorConnectionsTableDefinitionFactory.COLUMN_TIMESTAMP,
    );
    let lastEventColumn: BfxColDef = tableDefinition.getColumnDefinition(
      ConnectionMonitorConnectionsTableDefinitionFactory.COLUMN_LAST_EVENT,
    );

    eventTimeColumn.position = this.position.next();
    lastEventColumn.position = this.position.next();
    connectionGroupColumn.position = this.position.next();
    connectionColumn.position = this.position.next();
    sessionColumn.position = this.position.next();
    nodeColumn.position = this.position.next();

    td.addColumn(eventTimeColumn);
    td.addColumn(lastEventColumn);
    td.addColumn(connectionGroupColumn);
    td.addColumn(connectionColumn);
    td.addColumn(sessionColumn);
    td.addColumn(nodeColumn);

    return td;
  }

  public getBlotterType() {
    return BlotterType.OPSINTERVENTION;
  }

  public getAssetClass() {
    return AssetClass.FIX;
  }

  public getDefaultSortingModel(): any {
    return DEFAULT_SORT;
  }
}
